import { Controller } from "@hotwired/stimulus"
import { emitContentMediaSelected } from "../utils/events"

export default class extends Controller {

  static values = {
    args: Object // arguments à renvoyer avec l'event pour l'identifier chez le récepteur
  }

  get parentDialog() {
    return this.element.closest('[data-controller="dialog"]');
  }

  select(event) {
    const { id, action, ...file } = event.currentTarget.dataset;
    emitContentMediaSelected({ id, serialized_file: file }, { to: this.parentDialog, ...this.argsValue });
    window.closeParentDialog(this.element);
  }

}
